export default "__VITE_ASSET__BfFqMMu9__";